import { render, staticRenderFns } from "./CatalogNav.vue?vue&type=template&id=2c6bcedc&scoped=true&"
import script from "./CatalogNav.vue?vue&type=script&lang=js&"
export * from "./CatalogNav.vue?vue&type=script&lang=js&"
import style0 from "./CatalogNav.vue?vue&type=style&index=0&id=2c6bcedc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6bcedc",
  null
  
)

export default component.exports